/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindFeatureFlagByNameQueryResponse,
  FindFeatureFlagByNamePathParams,
} from "../types/FindFeatureFlagByName.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findFeatureFlagByNameQueryKey = (
  name: FindFeatureFlagByNamePathParams["name"] | undefined
) => [{ url: "/v1/feature-flags/:name", params: { name: name } }] as const

export type FindFeatureFlagByNameQueryKey = ReturnType<
  typeof findFeatureFlagByNameQueryKey
>

/**
 * {@link /v1/feature-flags/:name}
 */
export async function findFeatureFlagByName(
  name: FindFeatureFlagByNamePathParams["name"],
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindFeatureFlagByNameQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/v1/feature-flags/${name}`, ...requestConfig })
  return res
}

export function findFeatureFlagByNameQueryOptions(
  name: FindFeatureFlagByNamePathParams["name"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findFeatureFlagByNameQueryKey(name)
  return queryOptions<
    ResponseConfig<FindFeatureFlagByNameQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindFeatureFlagByNameQueryResponse>,
    typeof queryKey
  >({
    enabled: !!name,
    queryKey,
    queryFn: async ({ signal }) => {
      return findFeatureFlagByName(name!, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * {@link /v1/feature-flags/:name}
 */
export function useFindFeatureFlagByName<
  TData = ResponseConfig<FindFeatureFlagByNameQueryResponse>,
  TQueryData = ResponseConfig<FindFeatureFlagByNameQueryResponse>,
  TQueryKey extends QueryKey = FindFeatureFlagByNameQueryKey,
>(
  name: FindFeatureFlagByNamePathParams["name"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindFeatureFlagByNameQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findFeatureFlagByNameQueryKey(name)

  const query = useQuery(
    {
      ...findFeatureFlagByNameQueryOptions(name, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
